// src/components/static-multi-item-cross-sell/static-multi-item-cross-sell.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSActionDialogFooterFragment on EGDSDialogFooter {\n    ... on EGDSStackedDialogFooter {\n      buttons {\n        ...PackageUIActionDialogFooterButton\n      }\n    }\n    ... on EGDSInlineDialogFooter {\n      buttons {\n        ...PackageUIActionDialogFooterButton\n      }\n    }\n  }\n\n  fragment PackageUIActionDialogFooterButton on EGDSButton {\n    primary\n    ... on PackageUIActionDialogFooterButton {\n      style\n      dialogAction {\n        ... on PackageUIActionDialogFooterButtonCloseAction {\n          analytics {\n            referrerId\n            linkName\n          }\n        }\n        ... on PackageUIActionDialogSearchLinkAction {\n          newTabAccessibilityText\n          analytics {\n            referrerId\n            linkName\n          }\n          resource {\n            ... on HttpURI {\n              relativePath\n            }\n          }\n          target\n        }\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n    spotLight\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSIllustrationFragment on Illustration {\n    description\n    link: url\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    url {\n      value\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment UIGraphicFragment on UIGraphic {\n    ...EGDSIconFragment\n    ...EGDSMarkFragment\n    ...EGDSIllustrationFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment CrossSellLegalDisclaimerDialogFragment on CrossSellLegalDisclaimerDialog {\n    dialog {\n      closeAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      footer {\n        ...EGDSActionDialogFooterFragment\n      }\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n    text\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    referrerId\n    linkName\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment CrossSellMessageItemFragment on CrossSellMessageItem {\n    crossSellMessage\n    disclaimerDialog {\n      ...CrossSellLegalDisclaimerDialogFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment CrossSellSecondaryFragment on CrossSellSecondary {\n    ...CrossSellMessageItemFragment\n  }\n\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGUisMicroMessageFragment on EGUisMicroMessage {\n    messageContent\n    schemaName\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSPrimaryButtonFragment on UIPrimaryButton {\n    primary\n    accessibility\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    ...EGDSPrimaryButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment PackageUIButtonFragment on PackageUIButton {\n    button {\n      ...EGDSButtonFragment\n    }\n    action {\n      ...UILinkActionFragment\n    }\n  }\n\n  fragment UILinkActionFragment on UILinkAction {\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        ...EGUisMicroMessageFragment\n      }\n    }\n    resource {\n      value\n    }\n    target\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment CrossSellButtonActionFragment on CrossSellButtonAction {\n    label\n    resource {\n      value\n    }\n    icon {\n      id\n    }\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        ...EGUisMicroMessageFragment\n      }\n    }\n    accessibility\n  }\n\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment CrossSellLinkActionFragment on CrossSellLinkAction {\n    label\n    resource {\n      value\n    }\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        ...EGUisMicroMessageFragment\n      }\n    }\n    accessibility\n  }\n\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment CrossSellActionFragment on CrossSellAction {\n    ...CrossSellButtonActionFragment\n    ...CrossSellLinkActionFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  query StaticCrossSellQuery(\n    $context: ContextInput!\n    $searchContext: MultiItemSearchContextInput!\n    $userLocation: CrossSellUserLocationInput\n    $crossSellProductType: CrossSellProductType\n  ) {\n    crossSell(context: $context, searchContext: $searchContext) {\n      static {\n        searchResultListing(userLocation: $userLocation, crossSellProductType: $crossSellProductType) {\n          crossSell {\n            theme\n            header {\n              ...CrossSellMessageItemFragment\n            }\n            messageItems {\n              ...CrossSellMessageItemFragment\n              ...CrossSellLinkActionFragment\n              ...PackageUIButtonFragment\n            }\n            graphic {\n              ...UIGraphicFragment\n            }\n            action {\n              ...CrossSellLinkActionFragment\n            }\n            actionBar {\n              ...CrossSellActionFragment\n            }\n          }\n          impressionAnalytics {\n            referrerId\n            linkName\n          }\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
import React15 from "react";
import { gql as gql16, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ITrackType as ITrackType4, useClickstreamAnalytics as useClickstreamAnalytics4, useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
// ../internal/src/components/cross-sell-secondary/cross-sell-secondary.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// ../internal/src/components/cross-sell-secondary/cross-sell-message-item.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
// ../internal/src/components/cross-sell-secondary/cross-sell-legal-disclaimer-dialog.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkDialog, UitkDialogContent } from "uitk-react-dialog";
import { UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkSheetTransition } from "uitk-react-sheet";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/egds-action-dialog-footer/egds-action-dialog-footer.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkPrimaryButton, UitkTertiaryButton } from "uitk-react-button";
import { UitkDialogFooter } from "uitk-react-dialog";
var fragment = gql(_templateObject());
var _obj;
var buttonComponentMap = (_obj = {}, _define_property(_obj, "PRIMARY" /* PRIMARY */, UitkPrimaryButton), _define_property(_obj, "TERTIARY" /* TERTIARY */, UitkTertiaryButton), _obj);
var isValidButton = function (button) {
  return button.__typename === "PackageUIActionDialogFooterButton" && buttonComponentMap[button.style];
};
var getChildrenButtons = function (data, onDialogClose, track) {
  return data.buttons.filter(isValidButton).map(function (button, index) {
    if (button.__typename !== "PackageUIActionDialogFooterButton") {
      return null;
    }
    var Button = buttonComponentMap[button.style];
    var commonProps = {
      key: "dialog-footer-button-".concat(index),
      analytics: {
        id: button.dialogAction.analytics.referrerId,
        description: button.dialogAction.analytics.linkName,
        callback: function (id, description) {
          return track(id, description);
        }
      }
    };
    switch (button.dialogAction.__typename) {
      case "PackageUIActionDialogFooterButtonCloseAction":
        {
          return /* @__PURE__ */React.createElement(Button, _object_spread_props(_object_spread({}, commonProps), {
            onClick: onDialogClose
          }), button.primary);
        }
      case "PackageUIActionDialogSearchLinkAction":
        {
          var linkProps = {
            href: button.dialogAction.resource.__typename === "HttpURI" ? button.dialogAction.resource.relativePath : void 0,
            target: button.dialogAction.target === "EXTERNAL" /* EXTERNAL */ ? "_blank" : "_self",
            rel: "noopener noreferrer",
            onClick: onDialogClose
          };
          return linkProps.href ? /* @__PURE__ */React.createElement(Button, _object_spread({}, commonProps, linkProps), /* @__PURE__ */React.createElement(React.Fragment, null, button.primary, button.dialogAction.newTabAccessibilityText && /* @__PURE__ */React.createElement("span", {
            className: "is-visually-hidden"
          }, button.dialogAction.newTabAccessibilityText))) : null;
        }
      default:
        return null;
    }
  }).filter(Boolean);
};
var EGDSActionDialogFooter = function (param) {
  var data = param.data,
    onDialogClose = param.onDialogClose;
  var track = useClickTracker();
  var buttons = getChildrenButtons(data, onDialogClose, track);
  switch (data.__typename) {
    case "EGDSInlineDialogFooter":
      return /* @__PURE__ */React.createElement(UitkDialogFooter, {
        stacked: false
      }, buttons);
    case "EGDSStackedDialogFooter":
      return /* @__PURE__ */React.createElement(UitkDialogFooter, {
        stacked: true
      }, buttons);
    default:
      return null;
  }
};
EGDSActionDialogFooter.fragment = fragment;
EGDSActionDialogFooter.displayName = "EGDSActionDialogFooter";
// ../internal/src/components/ui-graphic/ui-graphic.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment2 = gql2(_templateObject1());
var _obj1;
var SPOTLIGHT_MAP = (_obj1 = {}, _define_property(_obj1, "INFO" /* INFO */, "info"), _define_property(_obj1, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj1, "STANDARD" /* STANDARD */, "standard"), _define_property(_obj1, "WARNING" /* WARNING */, "warning"), _obj1);
var EGDSIcon = function (param) {
  var data = param.data,
    defaultIconSize = param.defaultIconSize,
    defaultIconTheme = param.defaultIconTheme,
    defaultIconSpotLight = param.defaultIconSpotLight;
  var description = data.description,
    id = data.id,
    size = data.size,
    title = data.title,
    theme = data.theme,
    withBackground = data.withBackground,
    spotLight = data.spotLight;
  var _ref;
  return /* @__PURE__ */React2.createElement(UitkIcon, {
    description: description,
    id: id,
    name: id,
    size: size ? UitkIconSize[size] : defaultIconSize,
    title: title !== null && title !== void 0 ? title : void 0,
    theme: theme !== null && theme !== void 0 ? theme : defaultIconTheme,
    shadow: Boolean(withBackground),
    spotlight: (_ref = spotLight && SPOTLIGHT_MAP[spotLight] || defaultIconSpotLight) !== null && _ref !== void 0 ? _ref : void 0
  });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = fragment2;
// ../internal/src/components/egds-illustration/egds-illustration.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var fragment3 = gql3(_templateObject2());
var EGDSIllustration = function (param) {
  var data = param.data;
  return /* @__PURE__ */React3.createElement(UitkIllustrations, {
    alt: data.description,
    url: data.link
  });
};
EGDSIllustration.displayName = "EGDSIllustration";
EGDSIllustration.fragment = fragment3;
// ../internal/src/components/egds-mark/edgs-mark.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkMark } from "uitk-react-mark";
var fragment4 = gql4(_templateObject3());
var EGDSMark = function (param) {
  var data = param.data,
    size = param.size;
  var _data_url;
  if (!data.url && !data.id) {
    return null;
  }
  return /* @__PURE__ */React4.createElement(UitkMark, {
    description: data.description,
    id: data.id,
    name: data.id,
    size: size,
    url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
  });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = fragment4;
// ../internal/src/components/ui-graphic/ui-graphic.tsx
var fragment5 = gql5(_templateObject4(), EGDSIcon.fragment, EGDSMark.fragment, EGDSIllustration.fragment);
var UIGraphic = function (param) {
  var data = param.data,
    markProps = param.markProps,
    iconProps = param.iconProps;
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React5.createElement(EGDSIcon, _object_spread({
        data: data
      }, iconProps));
    case "Mark":
      return /* @__PURE__ */React5.createElement(EGDSMark, _object_spread({
        data: data
      }, markProps));
    case "Illustration":
      return /* @__PURE__ */React5.createElement(EGDSIllustration, {
        data: data
      });
    default:
      return null;
  }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment5;
// ../internal/src/components/cross-sell-secondary/cross-sell-legal-disclaimer-dialog.tsx
var fragment6 = gql6(_templateObject5(), UIGraphic.fragment, EGDSActionDialogFooter.fragment);
var CrossSellLegalDisclaimerDialog = function (param) {
  var data = param.data;
  var _useDialog = _sliced_to_array(useDialog("cross-sell-legal-disclaimer-dialog"), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    CrossSellLegalDisclaimerDialogComponent = _useDialog[2];
  var track = useClickTracker2();
  var triggerRef = React6.useRef(null);
  var graphic = data.graphic,
    dialog = data.dialog,
    analytics = data.analytics,
    text = data.text;
  var openDialog = function () {
    dialogActions.openDialog();
    track(analytics.referrerId, analytics.linkName);
  };
  var onClose = React6.useCallback(function () {
    dialogActions.closeDialog();
    if (dialog.closeAnalytics) {
      track(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
  }, [dialogActions, track, dialog.closeAnalytics]);
  return /* @__PURE__ */React6.createElement(React6.Fragment, null, /* @__PURE__ */React6.createElement(UitkLink, {
    inline: true,
    onClick: openDialog
  }, /* @__PURE__ */React6.createElement("button", {
    type: "button",
    ref: triggerRef
  }, /* @__PURE__ */React6.createElement(UitkText, null, /* @__PURE__ */React6.createElement(UIGraphic, {
    data: graphic,
    iconProps: {
      defaultIconSize: UitkIconSize2.SMALL
    }
  })))), /* @__PURE__ */React6.createElement(UitkSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React6.createElement(CrossSellLegalDisclaimerDialogComponent, null, /* @__PURE__ */React6.createElement(UitkDialog, {
    dialogShow: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef,
    closeCallback: onClose
  }, /* @__PURE__ */React6.createElement(UitkDialogContent, null, /* @__PURE__ */React6.createElement(UitkText, null, text), /* @__PURE__ */React6.createElement(EGDSActionDialogFooter, {
    data: dialog.footer,
    onDialogClose: onClose
  }))))));
};
CrossSellLegalDisclaimerDialog.fragment = fragment6;
CrossSellLegalDisclaimerDialog.displayName = "CrossSellLegalDisclaimerDialog";
// ../internal/src/components/cross-sell-secondary/cross-sell-message-item.tsx
var fragment7 = gql7(_templateObject6(), CrossSellLegalDisclaimerDialog.fragment);
var messageItemMargin = {
  inlineend: "half"
};
var CrossSellMessageItem = function (param) {
  var data = param.data,
    textWeight = param.textWeight,
    textTheme = param.textTheme;
  var crossSellMessage = data.crossSellMessage,
    disclaimerDialog = data.disclaimerDialog;
  return /* @__PURE__ */React7.createElement(React7.Fragment, null, /* @__PURE__ */React7.createElement(UitkSpacing, {
    margin: messageItemMargin
  }, /* @__PURE__ */React7.createElement(UitkText2, {
    size: 300,
    theme: textTheme,
    weight: textWeight,
    inline: true
  }, crossSellMessage)), disclaimerDialog && /* @__PURE__ */React7.createElement(CrossSellLegalDisclaimerDialog, {
    data: disclaimerDialog
  }));
};
CrossSellMessageItem.fragment = fragment7;
CrossSellMessageItem.displayName = "CrossSellMessageItem";
// ../internal/src/components/cross-sell-secondary/cross-sell-secondary.tsx
var fragment8 = gql8(_templateObject7(), CrossSellMessageItem.fragment);
var crossSellMessageItemPadding = {
  inline: "two",
  blockstart: "two"
};
var CrossSellSecondary = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "CrossSellMessageItem":
      return /* @__PURE__ */React8.createElement(UitkSpacing2, {
        padding: crossSellMessageItemPadding
      }, /* @__PURE__ */React8.createElement("div", null, /* @__PURE__ */React8.createElement(CrossSellMessageItem, {
        data: data
      })));
    default:
      return null;
  }
};
CrossSellSecondary.fragment = fragment8;
CrossSellSecondary.displayName = "CrossSellSecondary";
// ../internal/src/components/package-ui-button/package-ui-button.tsx
import React11 from "react";
import { gql as gql12 } from "@apollo/client";
import { ITrackType, useClickstreamAnalytics, useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/utils/uis-prime-utils.ts
var mapUisMicroMessage = function (uisPrimeMessages) {
  return uisPrimeMessages.map(function (uisPrimeMessage) {
    return {
      messageContent: JSON.parse(uisPrimeMessage.messageContent),
      schemaName: uisPrimeMessage.schemaName
    };
  });
};
// ../internal/src/__fragments/common/eg-uis-micro-message-fragment.ts
import { gql as gql9 } from "@apollo/client";
var EGUisMicroMessageFragment = gql9(_templateObject8());
// ../internal/src/components/egds-button/egds-button.tsx
import React10 from "react";
import { gql as gql11 } from "@apollo/client";
// ../internal/src/components/egds-button/egds-primary-button.tsx
import React9 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkPrimaryButton as UitkPrimaryButton2 } from "uitk-react-button";
var fragment9 = gql10(_templateObject9());
var EGDSPrimaryButton = function (param) {
  var data = param.data,
    onClick = param.onClick,
    size = param.size,
    isFullWidth = param.isFullWidth;
  var primary = data.primary,
    accessibility = data.accessibility;
  var buttonProps = {
    size: size,
    isFullWidth: isFullWidth
  };
  return /* @__PURE__ */React9.createElement(UitkPrimaryButton2, _object_spread({
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : "",
    onClick: onClick
  }, buttonProps), primary);
};
EGDSPrimaryButton.fragment = fragment9;
EGDSPrimaryButton.displayName = "EGDSPrimaryButton";
// ../internal/src/components/egds-button/egds-button.tsx
var fragment10 = gql11(_templateObject10(), EGDSPrimaryButton.fragment);
var EGDSButton = function (param) {
  var data = param.data,
    buttonProps = param.buttonProps;
  switch (data.__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React10.createElement(EGDSPrimaryButton, _object_spread({
        data: data
      }, buttonProps));
    default:
      return null;
  }
};
EGDSButton.fragment = fragment10;
EGDSButton.displayName = "EGDSButton";
// ../internal/src/components/package-ui-button/package-ui-button.tsx
var fragment11 = gql12(_templateObject11(), EGDSButton.fragment, EGUisMicroMessageFragment);
var _obj2;
var linkTargetMap = (_obj2 = {}, _define_property(_obj2, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj2, "INTERNAL" /* INTERNAL */, "_self"), _obj2);
var PackageUIButton = function (param) {
  var data = param.data,
    size = param.size,
    isFullWidth = param.isFullWidth;
  var track = useClickTracker3();
  var _useClickstreamAnalytics = useClickstreamAnalytics(),
    clickstreamTrack = _useClickstreamAnalytics.track;
  var button = data.button,
    action = data.action;
  var onClick = function () {
    if (action.__typename === "UILinkAction") {
      var analytics = action.analytics,
        resource = action.resource,
        target = action.target;
      track(analytics.referrerId, analytics.linkName);
      clickstreamTrack(ITrackType.EVENT, {
        data: mapUisMicroMessage(analytics.uisPrimeMessages)
      });
      window.open(resource.value, linkTargetMap[target]);
    }
  };
  return /* @__PURE__ */React11.createElement(EGDSButton, {
    buttonProps: {
      onClick: onClick,
      size: size,
      isFullWidth: isFullWidth
    },
    data: button
  });
};
PackageUIButton.fragment = fragment11;
PackageUIButton.displayName = "PackageUIButton";
// src/components/static-multi-item-cross-sell/static-multi-item-cross-sell.tsx
import { UitkButtonSize } from "uitk-react-button";
import { UitkCard, UitkCardActionArea, UitkCardContentSection, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkMarkSize as UitkMarkSize2 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
// src/mapper/messaging-theme-mapper.ts
import { UitkCardBackgroundThemes } from "@egds/react-core/cards";
var mapTheme = function (theme) {
  switch (theme) {
    case "PRIMARY" /* PRIMARY */:
      return UitkCardBackgroundThemes.PRIMARY;
    case "SECONDARY" /* SECONDARY */:
      return UitkCardBackgroundThemes.SECONDARY;
    case "HIGHLIGHT" /* HIGHLIGHT */:
      return UitkCardBackgroundThemes.HIGHLIGHT;
    default:
      return void 0;
  }
};
// src/components/static-multi-item-cross-sell/__private/__fragments/cross-sell-action.tsx
import React14 from "react";
import { gql as gql15 } from "@apollo/client";
// src/components/static-multi-item-cross-sell/__private/__fragments/cross-sell-button-action.tsx
import React12 from "react";
import { gql as gql13 } from "@apollo/client";
import { ITrackType as ITrackType2, useClickstreamAnalytics as useClickstreamAnalytics2, useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
import { UitkLink as UitkLink2 } from "uitk-react-link";
var fragment12 = gql13(_templateObject12(), EGUisMicroMessageFragment);
var CrossSellButtonAction = function (param) {
  var _param_data = param.data,
    label = _param_data.label,
    resource = _param_data.resource,
    icon = _param_data.icon,
    analytics = _param_data.analytics,
    accessibility = _param_data.accessibility;
  var track = useClickTracker4();
  var _useClickstreamAnalytics2 = useClickstreamAnalytics2(),
    clickstreamTrack = _useClickstreamAnalytics2.track;
  var onClickCapture = React12.useCallback(function () {
    track(analytics.referrerId, analytics.linkName);
    clickstreamTrack(ITrackType2.EVENT, {
      data: mapUisMicroMessage(analytics.uisPrimeMessages)
    });
  }, [analytics, clickstreamTrack, track]);
  return /* @__PURE__ */React12.createElement(UitkLink2, {
    align: "right",
    onClickCapture: onClickCapture,
    inline: true
  }, /* @__PURE__ */React12.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: resource.value
  }, label, accessibility && /* @__PURE__ */React12.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility), (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */React12.createElement(UitkIcon2, {
    name: icon.id
  })));
};
CrossSellButtonAction.fragment = fragment12;
CrossSellButtonAction.displayName = "CrossSellButtonAction";
// src/components/static-multi-item-cross-sell/__private/__fragments/crosssell-link-action.tsx
import React13 from "react";
import { gql as gql14 } from "@apollo/client";
import { ITrackType as ITrackType3, useClickstreamAnalytics as useClickstreamAnalytics3, useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink3 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
var fragment13 = gql14(_templateObject13(), EGUisMicroMessageFragment);
var CrossSellLinkAction = function (param) {
  var _param_data = param.data,
    label = _param_data.label,
    resource = _param_data.resource,
    analytics = _param_data.analytics,
    accessibility = _param_data.accessibility;
  var track = useClickTracker5();
  var _useClickstreamAnalytics3 = useClickstreamAnalytics3(),
    clickstreamTrack = _useClickstreamAnalytics3.track;
  var onClickCapture = React13.useCallback(function () {
    track(analytics.referrerId, analytics.linkName);
    clickstreamTrack(ITrackType3.EVENT, {
      data: mapUisMicroMessage(analytics.uisPrimeMessages)
    });
  }, [analytics, track, clickstreamTrack]);
  return /* @__PURE__ */React13.createElement(UitkSpacing3, {
    margin: {
      block: "two"
    }
  }, /* @__PURE__ */React13.createElement(UitkLink3, {
    onClickCapture: onClickCapture
  }, /* @__PURE__ */React13.createElement("a", {
    target: "_blank",
    rel: "noopener",
    href: resource.value
  }, label, accessibility && /* @__PURE__ */React13.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility))));
};
CrossSellLinkAction.fragment = _object_spread_props(_object_spread({}, fragment13), {
  __typename: "CrossSellLinkAction"
});
CrossSellLinkAction.displayName = "CrossSellLinkAction";
// src/components/static-multi-item-cross-sell/__private/__fragments/cross-sell-action.tsx
var fragment14 = gql15(_templateObject14(), CrossSellButtonAction.fragment, CrossSellLinkAction.fragment);
var CrossSellAction = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "CrossSellButtonAction":
      return /* @__PURE__ */React14.createElement(CrossSellButtonAction, {
        data: data
      });
    case "CrossSellLinkAction":
      return /* @__PURE__ */React14.createElement(CrossSellLinkAction, {
        data: data
      });
    default:
      return null;
  }
};
CrossSellAction.fragment = fragment14;
CrossSellAction.displayName = "CrossSellAction";
// src/components/static-multi-item-cross-sell/static-multi-item-cross-sell.tsx
var __Query = gql16(_templateObject15(), CrossSellAction.fragment, CrossSellLinkAction.fragment, CrossSellMessageItem.fragment, PackageUIButton.fragment, UIGraphic.fragment);
var crossSellMessageItemPadding2 = {
  block: "two"
};
var crossSellPackageUIButtonPadding = {
  blockstart: "two"
};
var StaticMultiItemCrossSell = function (param) {
  var inputs = param.inputs,
    skipSsr = param.skipSsr,
    NoResultsFallback = param.noResultsFallback,
    LoadingPlaceholder = param.loadingPlaceholder,
    outerSpacing = param.outerSpacing;
  var context = useBexApi().context;
  var track = useClickTracker6();
  var _useClickstreamAnalytics4 = useClickstreamAnalytics4(),
    clickstreamTrack = _useClickstreamAnalytics4.track;
  var isFlightsWhiteCanvasExperimentBucketed = useExperiment("Flights_Grey_to_White_Canvas_Web").exposure.bucket > 0;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  React15.useEffect(function () {
    if (data) {
      var _data_crossSell_static_searchResultListing_impressionAnalytics = data.crossSell.static.searchResultListing.impressionAnalytics,
        referrerId = _data_crossSell_static_searchResultListing_impressionAnalytics.referrerId,
        linkName = _data_crossSell_static_searchResultListing_impressionAnalytics.linkName;
      track(referrerId, linkName);
    }
    if (error) {
      track("mit.static.xsell.graphql.error", "Multi-Item static cross sell error");
    }
  }, [track, data, error]);
  if (loading) {
    return LoadingPlaceholder ? /* @__PURE__ */React15.createElement(LoadingPlaceholder, null) : null;
  }
  if (error || !data) {
    return NoResultsFallback ? /* @__PURE__ */React15.createElement(NoResultsFallback, null) : null;
  }
  var _data_crossSell_static_searchResultListing_crossSell = data.crossSell.static.searchResultListing.crossSell,
    header = _data_crossSell_static_searchResultListing_crossSell.header,
    theme = _data_crossSell_static_searchResultListing_crossSell.theme,
    messageItems = _data_crossSell_static_searchResultListing_crossSell.messageItems,
    graphic = _data_crossSell_static_searchResultListing_crossSell.graphic,
    _data_crossSell_static_searchResultListing_crossSell_action = _data_crossSell_static_searchResultListing_crossSell.action,
    label = _data_crossSell_static_searchResultListing_crossSell_action.label,
    resource = _data_crossSell_static_searchResultListing_crossSell_action.resource,
    analytics = _data_crossSell_static_searchResultListing_crossSell_action.analytics,
    accessibility = _data_crossSell_static_searchResultListing_crossSell_action.accessibility,
    actionBar = _data_crossSell_static_searchResultListing_crossSell.actionBar;
  var messageItemsContainer = messageItems.map(function (item, index) {
    switch (item.__typename) {
      case "CrossSellMessageItem":
        return /* @__PURE__ */React15.createElement("div", {
          key: "message-item-".concat(index)
        }, /* @__PURE__ */React15.createElement(CrossSellMessageItem, {
          data: item
        }));
      case "PackageUIButton":
        return /* @__PURE__ */React15.createElement(UitkSpacing4, {
          margin: crossSellPackageUIButtonPadding
        }, /* @__PURE__ */React15.createElement("div", {
          key: "message-item-".concat(index)
        }, /* @__PURE__ */React15.createElement(PackageUIButton, {
          data: item,
          size: UitkButtonSize.SMALL
        })));
      case "CrossSellLinkAction":
        return /* @__PURE__ */React15.createElement("div", {
          key: "message-item-".concat(index)
        }, /* @__PURE__ */React15.createElement(CrossSellLinkAction, {
          data: item
        }));
      default:
        return null;
    }
  });
  var onClickCapture = function () {
    track(analytics.referrerId, analytics.linkName);
    clickstreamTrack(ITrackType4.EVENT, {
      data: mapUisMicroMessage(analytics.uisPrimeMessages)
    });
  };
  return /* @__PURE__ */React15.createElement(UitkSpacing4, {
    padding: outerSpacing === null || outerSpacing === void 0 ? void 0 : outerSpacing.padding
  }, /* @__PURE__ */React15.createElement(UitkCard, {
    "data-stid": "static-cross-sell__main",
    border: isFlightsWhiteCanvasExperimentBucketed,
    backgroundTheme: mapTheme(theme)
  }, /* @__PURE__ */React15.createElement(UitkLayoutFlex, null, /* @__PURE__ */React15.createElement(UitkLayoutFlexItem, {
    alignSelf: "center",
    grow: 0
  }, /* @__PURE__ */React15.createElement(UitkCardContentSection, {
    padded: ["blockstart", "blockend", "inlinestart"]
  }, graphic && /* @__PURE__ */React15.createElement(UitkCardContentSection, {
    padded: false
  }, /* @__PURE__ */React15.createElement(UIGraphic, {
    data: graphic,
    markProps: {
      size: UitkMarkSize2.MEDIUM_LARGE
    }
  })))), /* @__PURE__ */React15.createElement(UitkLayoutFlexItem, {
    grow: 1
  }, /* @__PURE__ */React15.createElement(UitkCardContentSection, {
    padded: true
  }, /* @__PURE__ */React15.createElement(UitkSpacing4, {
    margin: crossSellMessageItemPadding2
  }, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(CrossSellMessageItem, {
    data: header,
    textWeight: "bold",
    textTheme: "emphasis"
  }))), /* @__PURE__ */React15.createElement("div", null, messageItemsContainer)))), (actionBar === null || actionBar === void 0 ? void 0 : actionBar.length) && /* @__PURE__ */React15.createElement(UitkCardActionArea, null, /* @__PURE__ */React15.createElement(UitkLayoutFlex, {
    alignItems: "end",
    direction: "column"
  }, /* @__PURE__ */React15.createElement("div", null, actionBar.map(function (actionBarItem, index) {
    return /* @__PURE__ */React15.createElement(CrossSellAction, {
      data: actionBarItem,
      key: "action-bar-".concat(index)
    });
  })))), /* @__PURE__ */React15.createElement(UitkCardLink, null, /* @__PURE__ */React15.createElement("a", {
    onClickCapture: onClickCapture,
    "data-stid": "static-cross-sell__card-link",
    target: "_blank",
    rel: "noopener",
    href: resource.value
  }, label, accessibility && /* @__PURE__ */React15.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)))));
};
StaticMultiItemCrossSell.displayName = "sharedui-StaticMultiItemCrossSell";
export { StaticMultiItemCrossSell }; /* istanbul ignore file -- @preserve */